var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{ref:"modal",attrs:{"id":"login-modal","hide-footer":"","size":"lg","centered":""},on:{"show":_vm.show}},[_c('LoginForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }